export const common = {
  welcome: '歡迎',
  home: '首頁',
  about: '關於我們',
  services: '服務',
  contact: '聯絡我們',
  learnMore: '了解更多',
  getStarted: '開始',
  submit: '提交',
  cancel: '取消',
  close: '關閉',
  save: '儲存',
  edit: '編輯',
  delete: '刪除',
  search: '搜尋',
  loading: '載入中...',
  error: '發生錯誤',
  success: '成功',
  reserveNow: '立即預訂',
};